<template>
  <span 
    :class="{ 'i18n-editable': isEditMode }" 
    :data-i18n-key="tKey" 
    :data-i18n-locale="locale"
    @click="handleClick"
  >
    {{ translationValue }}
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { getI18n } from '@/plugins/i18nEditorPlugin';

export default defineComponent({
  name: 'I18nText',
  props: {
    /**
     * Translation key (e.g., 'committee.details.title')
     */
    tKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isEditMode: false,
      translationValue: '',
      locale: 'en',
      editModeCheckInterval: null as any,
    };
  },
  computed: {
    i18n() {
      return getI18n();
    },
  },
  watch: {
    '$i18n.locale': {
      handler() {
        this.updateTranslation();
      },
    },
  },
  mounted() {
    this.updateTranslation();
    this.checkEditMode();

    // Listen for edit mode changes
    this.editModeCheckInterval = setInterval(() => {
      this.checkEditMode();
    }, 100);
  },
  beforeUnmount() {
    if (this.editModeCheckInterval !== null) {
      clearInterval(this.editModeCheckInterval);
    }
  },
  methods: {
    updateTranslation() {
      const i18n = this.i18n;
      if (!i18n) return;

      this.locale = i18n.global.locale.value;
      const messages = i18n.global.getLocaleMessage(this.locale);
      this.translationValue = this.getNestedProperty(messages, this.tKey) || this.tKey;
    },

    checkEditMode() {
      this.isEditMode = window.__I18N_EDIT_MODE__ || false;
    },

    getNestedProperty(obj: any, path: string): any {
      const keys = path.split('.');
      let current = obj;

      for (const key of keys) {
        if (current && typeof current === 'object' && key in current) {
          current = current[key];
        } else {
          return undefined;
        }
      }

      return current;
    },

    handleClick() {
      if (this.isEditMode && window.__I18N_EDITOR__) {
        window.__I18N_EDITOR__.openModal(this.tKey, this.locale, this.translationValue);
      }
    },
  },
});
</script>

<style scoped>
.i18n-editable {
  border-bottom: 2px dashed var(--color-border);
  cursor: pointer;
  transition: 0.2s;
  padding: 0 2px;
}

.i18n-editable:hover {
  border-bottom-color: #0066cc;
  background-color: rgba(0, 102, 204, 0.05);
}
</style>
